module.exports = __webpack_public_path__ + "img/YouLostMailShip_1500x1500.17614914.png";